import { render } from "./traCourseDetail.vue?vue&type=template&id=1cf68b52&scoped=true"
import script from "./traCourseDetail.vue?vue&type=script&lang=js"
export * from "./traCourseDetail.vue?vue&type=script&lang=js"

import "./traCourseDetail.vue?vue&type=style&index=0&id=1cf68b52&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf68b52"]])

export default __exports__